import initialEditorRender from './initial-editor-render';
import externalImagePaster from './external-image-paster';
import initialSettingsSetup from './initial-settings-setup';

export default {
  externalImagePaster,
  initialEditorRender,
  initialSettingsSetup,
};
